<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="앨범 게시물 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <!-- 그룹 드롭다운 리스트 선택 -->
                <admin-form-item label="*팀 선택">
                  <div v-if="param_group_id!==''">{{ selectedGroup }}</div>
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="groupList"
                                     :selectVal="selectedGroup"
                                     @onSelect="res => group_id=res.value"
                                     placeholder="팀 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;" v-else></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="*게시물 제목">
                  <input class="input"
                         style="width:250px"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="*게시물 내용">
                  <lp-editor :text.sync="value.content"></lp-editor>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="업로드 이미지">
                  <drag-img-multiple :imgs.sync="value.imgs"></drag-img-multiple>
                  <!--<input-img-multiple
                    :images.sync="value.imgs"
                    class="item"></input-img-multiple>-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="동영상 링크">
                  <input class="input"
                         placeholder="Youtube, Vimeo 링크 및 mp4 링크 삽입"
                         :value="value.video"
                         @input="e => value.video = e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <lp-check-bool :checked-val.sync="value.activate_comment"
                               label="댓글 활성화 여부"></lp-check-bool>
              </div>
              <div class="column is-full">
                <lp-check-bool :checked-val.sync="value.is_secret"
                               label="비밀글 여부"></lp-check-bool>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="post_id > 0">
          <admin-box-item title="댓글 등록">
            <!-- 댓글 목록 -->
            <div>
              <div class="comment-sub-title">
                댓글 목록 ({{ commentsArr.length }})
                <i v-if="isComment===false" @click="isComment=true" class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                <i v-if="isComment===true" @click="isComment=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>
              </div>
              <div style="padding:12px">
                <div
                  v-if="isComment===true"
                  v-for="(item, idx) in commentsArr" :key="'comments'+idx"
                  style="margin-top: 12px;">
                  <div
                    v-if="idx!==0"
                    style="margin: 15px 0; width: 100%; height: 1px; background: #ddd;"></div>
                  <div style="display:flex; font-size: .9rem; color: #555; justify-content: space-between;">
                    <div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성자</div>
                        <div>{{ item.display_name }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성일</div>
                        <div>{{ item.created_time }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성내용</div>
                        <div>{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="buttons" v-if="!item.is_deleted">
                      <button @click="commentsUpdate(item)" class="button" style="padding: 6px 10px;">수정</button>
                      <button @click="commentsDelete(item)" class="button is-danger" style="padding: 6px 10px;">삭제</button>
                    </div>
                    <div v-else>삭제된 댓글입니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 댓글 작성 -->
            <div>
              <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
              <admin-form-item label="작성자" style="margin-bottom:20px">
                관리자
              </admin-form-item>
              <admin-form-item label="작성 내용">
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important"
                            @click="commentsReg">등록</button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>

        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import LpEditor from "../../../module/common/LpEditor";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import GroupMixin from "@/mixins/GroupMixin"
  import CreateMixin from "@/mixins/CreateMixin"
  import DragImgMultiple from "../../../module/common/DragImgMultiple";


  export default {
    mixins: [
      GroupMixin,
      CreateMixin
    ],
    name: 'AlbumPostCreate',
    components: {
      DragImgMultiple,
      LpCheckBool,
      LpEditor,
      InputImg,
      LpAdmDropInput,
      draggable
    },
    data() {
      return {
        group_id: 0,
        album_id: 1,
        post_id: undefined,
        groupList: [],
        value: {
          title:'',
          content:'',
          is_public: true,
          imgs: [''],
          video: '',
          tags:[],
          activate_comment: true,
          is_secret: false
        },
        commentsArr: [],
        // 댓글 작성
        comments: {
          id: "", // 상품문의상세 게시글 id
          content: "",
          /*writer: "",
          writer_type: "",
          writer_name: "",
          writer_username: "",
          date: "",
          lock: false // 비밀댓글 여부*/
        },
        userlist: [],
        isComment: false, // 댓글 목록 fold/unfold
      }
    },
    created() {
      this.getData();
      if(this.post_id) {
        this.getComment();
      }
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.getData();
      }
    },
    methods: {
      getData() {
        this.getGroupList('groupList');
        this.value = {
          title:'',
          content:'',
          is_public: true,
          imgs: [''],
          video: '',
          tags:[],
          activate_comment: true,
          is_secret: false
        };
        this.post_id = this.$route.query.post_id;
        this.album_id = this.$route.query.album_id ? parseInt(this.$route.query.album_id) : 1;
        this.group_id = this.$route.query.group_id ? parseInt(this.$route.query.group_id) : '';
        if(this.group_id === '')
          this.group_id = this.param_group_id;

        if(this.post_id) {
          this.$axios.get(this.getUrl(`group/${this.group_id}/album/${this.album_id}/post/${this.post_id}`)).then(res=>{
            this.value = res.data;

          })
        }
      },
      saveData() {
        if(!this.value.title) {
          this.toast('제목을 입력하세요.');
          return;
        }
        if(!this.value.content) {
          this.toast('내용을 입력하세요.');
          return;
        }
        if(this.post_id) {
          this.$axios.patch(this.getUrl(`group/${this.group_id}/album/${this.album_id}/post/${this.post_id}`), this.value).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath(`group/album/post?group_id=${this.group_id}&album_id=${this.album_id}`));
            }
          })
        }
        else {
          this.$axios.post(this.getUrl(`group/${this.group_id}/album/${this.album_id}/post`), this.value).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath(`group/album/post?group_id=${this.group_id}&album_id=${this.album_id}`));
            }
          })
        }
      },
      getComment() {
        let url = `group/${this.group_id}/album/${this.album_id}/post/${this.post_id}/comment`;
        this.$axios.get(this.getUrl(url))
          .then(res=>{
            this.commentsArr = res.data.data;
            if(res.data.user_type==='admin'){
              this.comment_user_type = 'admin';
              this.comment_user_id = res.data.admin;
            }
            else if(res.data.user_type==='user'){
              this.post_user_type = 'user';
              this.comment_user_id = res.data.user;
            }
          })
      },
      // 삭제
      commentsDelete(item) {
        let url = `group/${this.group_id}/album/${this.album_id}/post/${this.post_id}/comment/${item.id}`;
        this.$axios.delete(this.getUrl(url))
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getComment();

              this.comments = {
                id: "",
                content: ""
              }
            }
          })

      },
      // 수정
      commentsUpdate(item) {
        //console.log(item)
        this.comments.id = item.id;
        this.comments.content = item.content;
      },
      // 댓글 등록
      commentsReg() {
        if(!this.comments.id){
          let url = `group/${this.group_id}/album/${this.album_id}/post/${this.post_id}/comment`;
          this.$axios.post(this.getUrl(url), {
            content: this.comments.content,
            user_id: this.comment_user_id,
            user_type: this.comment_user_type
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
              if(!this.isComment){
                this.isComment = true;
              }
            }
          })

          this.comment_user_id = '';
          this.comment_user_type = '';
          this.comment_username = '';
        }
        else{
          let url = `group/${this.group_id}/album/${this.album_id}/post/${this.post_id}/comment/${this.comments.id}`;
          this.$axios.patch(this.getUrl(url), {
            content: this.comments.content,
            user_id: this.comment_user_id,
            user_type: this.comment_user_type
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
            }
          })

          this.comment_user_id = '';
          this.comment_user_type = '';
          this.comment_username = '';
        }
      },
      getUserList(){
        this.$axios.get('public/user/whole').then(res=>{
          this.userlist = res.data;
        })
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }
</style>
